import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Download, X, Upload } from "lucide-react";
import { formatBytes } from "./useImageCompression";

export default function StatsPanel({
  stats,
  images,
  isProcessing,
  comparisonMode,
  onDownloadSingle,
  onDownloadAll,
  onClearAll,
  onAddMore
}) {
  return (
    <div className="flex flex-col lg:flex-row gap-4 items-start lg:items-center justify-between">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 flex-1 w-full">
        <Card className="stat-card border-slate-200 dark:border-slate-700 dark:bg-slate-800 shadow-sm transition-colors duration-300">
          <CardContent className="p-4">
            <p className="text-xs font-bold uppercase tracking-wider text-slate-500 dark:text-slate-400 mb-1">Total Original</p>
            <p className="text-xl font-bold text-slate-900 dark:text-white">{formatBytes(stats.totalOriginal)}</p>
          </CardContent>
        </Card>

        <Card className="stat-card border-slate-200 dark:border-slate-700 dark:bg-slate-800 shadow-sm transition-colors duration-300">
          <CardContent className="p-4">
            <p className="text-xs font-bold uppercase tracking-wider text-slate-500 dark:text-slate-400 mb-1">After Compressed</p>
            <p className="text-xl font-bold text-blue-600 dark:text-blue-400">{formatBytes(stats.totalCompressed)}</p>
          </CardContent>
        </Card>

        <Card className="stat-card border-emerald-200 dark:border-emerald-800 bg-emerald-50 dark:bg-emerald-900/30 shadow-sm transition-colors duration-300">
          <CardContent className="p-4">
            <p className="text-xs font-bold uppercase tracking-wider text-emerald-700 dark:text-emerald-400 mb-1">Total Saved</p>
            <p className="text-xl font-bold text-emerald-600 dark:text-emerald-400">
              {stats.percentage}%
            </p>
          </CardContent>
        </Card>
      </div>

      <div className="flex flex-wrap gap-2 w-full lg:w-auto">
        {!comparisonMode && images.length > 0 && (
          <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
            <Button
              data-testid="download-all-button"
              onClick={() => images.length === 1 ? onDownloadSingle(images[0]) : onDownloadAll()}
              disabled={isProcessing}
              className="btn-primary rounded-full px-6 py-6 shadow-lg shadow-blue-500/20 font-bold bg-blue-600 hover:bg-blue-700 text-white w-full sm:w-auto"
            >
              <Download className="w-4 h-4 mr-2" />
              {images.length === 1 ? 'Download' : `Download All (${images.length})`}
            </Button>
            <Button
              data-testid="clear-all-button"
              onClick={onClearAll}
              disabled={isProcessing}
              variant="outline"
              className="rounded-full px-6 py-6 border-2 border-red-500 dark:border-red-600 bg-red-50 dark:bg-red-900/20 hover:bg-red-100 dark:hover:bg-red-900/30 hover:border-red-600 text-red-600 dark:text-red-400 font-medium w-full sm:w-auto transition-colors duration-300"
            >
              <X className="w-4 h-4 mr-2" />
              {images.length === 1 ? 'Clear' : 'Clear All'}
            </Button>
          </div>
        )}
        <Button
          data-testid="new-image-button"
          onClick={onAddMore}
          variant="outline"
          className="rounded-full px-6 py-6 border-2 border-slate-200 dark:border-slate-600 hover:border-slate-300 dark:hover:border-slate-500 bg-transparent text-slate-700 dark:text-slate-200 font-medium transition-colors duration-300"
        >
          <Upload className="w-4 h-4 mr-2" />
          Add More Images
        </Button>
      </div>
    </div>
  );
}
